import { atom, selector } from 'recoil'

import type {
  ResultsState,
  SearchFromCounterState,
  SearchState,
} from 'Pages/GroupsOverlap/model'

export const searchState = atom<SearchState>({
  key: 'groupsOverlap_searchState',
  default: {
    from: undefined,
    fromIsDirty: false,
    to: [],
    toIsDirty: false,
  },
})

export const searchFromCounterState = atom<SearchFromCounterState>({
  key: 'groupsOverlap_searchFromCounterState',
  default: {
    status: 'initial',
  },
})

export const canSearchState = selector({
  key: 'groupsOverlap_canSearchState',
  get: ({ get }) => {
    const { from, to } = get(searchState)

    return from !== undefined && to.length > 0
  },
})

export const resultsState = atom<ResultsState>({
  key: 'groupsOverlap_resultsState',
  default: {
    status: 'initial',
  },
})
